// This file is generated by pnpm icons:generate. Do not edit.

import {HomeOpen_Filled_Corner0_Rounded as CanonicalHomeOpen_Filled_Corner0_Rounded} from './Home'
import {HomeOpen_Stroke2_Corner0_Rounded as CanonicalHomeOpen_Stoke2_Corner0_Rounded} from './Home'

/** @deprecated Import HomeOpen_Filled_Corner0_Rounded from `#/components/icons/Home` instead. */
export const HomeOpen_Filled_Corner0_Rounded =
  CanonicalHomeOpen_Filled_Corner0_Rounded

/** @deprecated Import HomeOpen_Stroke2_Corner0_Rounded from `#/components/icons/Home` instead. */
export const HomeOpen_Stoke2_Corner0_Rounded =
  CanonicalHomeOpen_Stoke2_Corner0_Rounded
